export default __webpack_public_path__ + "static/media/noGoActive.2bf9cd8e.svg";